<template>
  <el-dialog
    :visible.sync="visible"
    width="100vw"
    class="purchase-list-dialog"
    :show-close="false"
    center
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="dialog-header">
      <img src="@/assets/images/logo-active.png" alt="logo" class="logo" />
      <button class="close-btn" @click="closeDialog">×</button>
    </div>
    <div class="table-container">
      <div class="table-box">
        <div class="table-body">
          <div
            class="table-row"
            v-for="(item, idx) in list"
            :key="idx"
          >
            <div class="col col-info">
              <div class="prod-title">{{ item.name }}</div>
              <div class="prod-info">
                <div>{{ getText('purchaseListDialog.productCode', '商品编号：') }}{{ item.b2starNo }}</div>
                <div>{{ getText('purchaseListDialog.itemNumber', '货号：') }}{{ item.sn }}</div>
                <div>{{ getText('purchaseListDialog.specification', '规格：') }}{{ item.specification }}</div>
                <div>{{ getText('purchaseListDialog.parameter', '参数：') }}{{ item.param }}</div>
              </div>
            </div>
            <div class="col col-price">
              <div class="price" v-if="item.price !== '0.0'">￥{{item.price}}<span class="unit">/{{item.unitName}}</span></div>
              <div class="price" v-else>{{ getText('purchaseListDialog.contactSales', '联系销售询价') }}</div>
            </div>
            <div class="col col-more">
              <el-button type="primary" size="mini" @click="goToShop(item)">{{ getText('purchaseListDialog.gotoShop', '前往商城查看') }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-box">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>
    <div class="dialog-footer">
      <img src="https://file.yacoo.com.cn/staticResource/other/kycg/logo.webp?x-oss-process=image/resize,w_120" alt="bztstar" class="bztstar" />
      <span>由亚科集团旗下星元素甄选提供服务</span>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PurchaseListDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 强制重新渲染组件以更新文本
          this.$forceUpdate()
        }
      },
      immediate: false
    }
  },

  computed: {
    ...mapState({
      currentLanguage: state => state?.app?.language || 'zh'
    })
  },
  methods: {
    // 安全的文本获取方法
    getText(key, fallback) {
      try {
        // 尝试使用 i18n
        if (this.$i18n && this.$i18n.t) {
          return this.$i18n.t(key)
        }
        // 如果 i18n 不可用，返回默认值
        return fallback
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error)
        return fallback
      }
    },
    goToShop(item) {
      this.$emit('update:visible', false)
      window.open('https://www.b2star.com' + item.goodsUrl, '_blank')
    },
    closeDialog() {
      this.$emit('update:visible', false)
    },
    handlePageChange(page) {
      // 通知父组件切换页码，父组件负责请求新数据
      this.$emit('page-change', page)
    }
  }
}
</script>

<style scoped>
.purchase-list-dialog ::v-deep .el-dialog__header {
  display: none;
}
.purchase-list-dialog ::v-deep .el-dialog {
  width: 100vw !important;
  max-width: 100vw;
  margin: 0;
  border-radius: 0;
  padding: 0;
}
.table-container {
  max-height: none;
  overflow: visible;
  margin-bottom: 8px;
  padding: 0 12px;
}
.table-box {
  background: #fff;
  border-radius: 8px;
  margin: 0 0 12px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}
.table-header, .table-row {
  display: block;
  padding: 0;
}
.table-header {
  background: #f7f7f7;
  border-radius: 8px 8px 0 0;

  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
}
.table-header .col {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
}
.table-body {
  max-height: none;
  overflow: visible;
}
.table-row {
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  margin-bottom: 8px;
  border-radius: 8px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.col {
  padding: 0 8px;
  font-size: 14px;
}
.col-info {
  font-size: 15px;
  color: #222;
}
.col-price {
  color: #e60012;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  margin-top: 4px;
}
/deep/ .col-more {
  text-align: right;
  margin-top: 4px;
    .el-button {
      color: #fff;
      background-color: var(--primary-color);
    }
}
.prod-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}
.prod-info {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}
.price {
  color: #e60012;
  font-size: 16px;
  font-weight: 600;
}
.unit {
  font-size: 13px;
  font-weight: 400;
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  color: #888;
  font-size: 13px;
  flex-direction: column;
  gap: 4px;
}
.bztstar {
  height: 18px;
  margin-right: 0;
  margin-bottom: 2px;
}
.pagination-box {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
.close-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  background: none;
  border: none;
  font-size: 24px;
  color: #888;
  cursor: pointer;
  outline: none;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #e60012;
}
.dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 0 12px 0;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 8px;
}
.logo {
  width: auto;
  height: 32px;
}
</style>